module.exports = __webpack_public_path__ + "img/lg_ring_y_o_1_0@2x.fce16dd2.png";